export default __webpack_public_path__ + "static/media/SJA1560.34I-43111_-25779_0.070375a5.jpg";